import React from 'react';

import { GlobalStyles } from '@mui/material';
import { portalledToolbarStyles } from 'app/shared/components/forms/PrismPagelessEditor/PrismPagelessEditor.styles';

const emailCreationGlobalStylesValue = {
  body: {
    '& .ck.ck-balloon-panel': {
      zIndex: 1500,
    },
  },
};

/* Fixes CKEditor's popups under MUI Modal on EmailCreationModal */
export const EmailCreationGlobalStyles = () => (
  <GlobalStyles styles={emailCreationGlobalStylesValue} />
);

export const getStyles = ({ palette }) => ({
  modalContainer: {
    width: '80vw',
    height: '80vh',
    position: 'relative',
    '& .MuiFormHelperText-root': {
      position: 'initial',
    },
    // dropdowns (like paragraph), toolbar, dropdowns panels (like font color)
    '& .ck.ck-list__item, .ck.ck-toolbar, .ck.ck-dropdown__panel': {
      backgroundColor: palette.background.paper,
    },
    '& .ck.ck-dropdown__panel .ck-list': {
      backgroundColor: palette.background.paper,
      maxHeight: '30vh',
      overflowY: 'auto',

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: palette.grey[500],
        border: '3px solid transparent',
        backgroundClip: 'content-box',
      },
      '&::-webkit-scrollbar-corner': {
        backgroundColor: 'transparent',
      },
    },
    // whole toolbar module
    '& .ck.ck-toolbar': {
      flexGrow: 1,
      border: `1px solid ${palette.divider}`,
    },
    '& .prism-editor--pageless': portalledToolbarStyles,
    '& .ck.ck-button': {
      color: palette.text.primary,
    },
    '& .ck.ck-button:not(.ck-disabled):hover': {
      background: palette.divider,
    },
    '& .ck-button__label': {
      lineHeight: 1.25,
    },
  },
  themeTextColor: {
    // CKEditor wraps text blocks with tables and with style (not inline)
    '& td': {
      color: `${palette.text.primary} !important`,
    },
  },
  bodyContainer: {
    '& .ck.ck-editor__main > .ck-editor__editable': {
      backgroundColor: palette.background.paper,
      border: '0',
      overflow: 'hidden', // to remove extra scroll on resize image
      paddingBottom: '5px', // to make bottom resize edges visible
      '&.ck-focused': {
        border: '0',
        boxShadow: 'none',
      },
      '&.ck-content ol ol': {
        listStyleType: 'decimal',
      },
      '&.ck-content .page-break': {
        display: 'block',
      },
    },
    '& .ck-editor__editable': {
      minHeight: '10rem',
    },
  },
  // The Prism field's frame keeps a gap from the toolbar row above it, in both states, so the body
  // does not move when the error frame appears.
  prismBodyContainer: {
    paddingTop: '4px',
  },
  bodyError: {
    '& .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused)': {
      border: `1px ${palette.error.main} solid`,
    },
  },
  fileCard: {
    backgroundColor: palette.primary.main,
  },
  dropZone: {
    border: `5px dashed ${palette.text.primary}`,
    backgroundColor: palette.background.paper,
    zIndex: 9999,
  },
  // Scoped to the row (`& >`): the Prism field below has the same pageless class and must keep its
  // own frame colour, the red error frame included.
  toolbar: {
    '& > .prism-editor--pageless': {
      display: 'flex',
      '& > .prism-toolbar-fieldset': {
        display: 'flex',
        flexGrow: 1,
        minWidth: 0,
      },
      '& .prism-toolbar': {
        '--prism-field-border': palette.divider,
        flexGrow: 1,
        borderBottom: `1px solid ${palette.divider}`,
      },
    },
  },
  snippetButtonContainer: {
    border: `1px solid ${palette.divider}`,
    borderRadius: 0,
    borderRight: 0,
  },
  prismSnippetButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  snippetButton: {
    fontWeight: 400,
    borderRadius: 0,
    margin: 'calc(0.6em*0.5)', // var from CKEditor
    padding: 'calc(0.6em*0.5) 0.6em', // var from CKEditor
  },
  snippetList: {
    maxWidth: '30vw',
    maxHeight: '30vh',
    overflowY: 'auto',
  },
});
